import { render, staticRenderFns } from "./OrbitEndRoundModal.vue?vue&type=template&id=7f83c0fa"
import script from "./OrbitEndRoundModal.vue?vue&type=script&lang=ts"
export * from "./OrbitEndRoundModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitEndRoundModal.vue?vue&type=style&index=0&id=7f83c0fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports